class DistanceView {
	_parentEl = document.querySelector('.distance')

	_generateMarkup(el) {
		return ` <tr>
	<td class="loading-street">${el.loadingStreet}</td>
	<td class="loading-postcode">${el.loadingPostcode}</td>
	<td class="loading-city">${el.loadingCity}</td>
	<td class="unloading-street">${el.unloadingStreet}</td>
	<td class="unloading-postcode">${el.unloadingPostcode}</td>
	<td class="unloading-city">${el.unloadingCity}</td>
	<td class="distance-value">${el.distance}</td>
	</tr>`
	}

	_generateMsgMarkup(error = '', success = '') {
		return `
		 <div class="msg show-msg">
                        <i class="fa-solid ${success ? 'fa-circle-check' : 'fa-triangle-exclamation'}"></i>
                        <p>${success || error}</p>
                    </div>`
	}

	_generateSpinner() {
		return `
		<div class="spinner"></div>
		`
	}

	handlerToggleForm() {
		this._parentEl.addEventListener('click', e => {
			const target = e.target.closest('.distance__box-title')
			if (!target) return
			this._formHidden()
		})
	}

	_formHidden = () => {
		this._parentEl.querySelector('.fa-arrow-down').classList.toggle('active')
		this._parentEl.querySelector('.form').classList.toggle('form__active')
	}

	updateUI = function () {
		this._parentEl.querySelector('.table-distance').classList.remove('hidden')
		this._formHidden()
	}

	addHandlerClick(handler) {
		this._parentEl.querySelector('.table__actions').addEventListener('click', e => {
			const btn = e.target.closest('.fa-arrow-down-short-wide')
			if (!btn) return
			handler()
		})
	}

	MsgTimeout = function (parentEl, msg, index) {
		setTimeout(() => {
			parentEl.insertAdjacentHTML('beforeend', msg)

			const item = parentEl.lastElementChild
			item.classList.add('show-msg')

			setTimeout(() => item.remove(), 5000)
		}, index * 1000)
	}

	renderMsg = function (errors = [], success = []) {
		const errorContainer = this._parentEl.querySelector('.errors-container')
		const messages = errors.concat(success)
		this._hidespinner()

		messages.forEach((msg, index) => {
			const isSuccess = success.includes(msg)

			const html = this._generateMsgMarkup(isSuccess ? '' : msg, isSuccess ? msg : '')

			this.MsgTimeout(errorContainer, html, index)
		})
	}

	_hidespinner = function () {
		const spinner = this._parentEl.querySelector('.spinner')
		if (spinner) spinner.remove()
	}

	renderDistanceTable = function (addresses) {
		this._hidespinner()
		const tableBody = this._parentEl.querySelector('.table__body')

		tableBody.innerHTML = ''

		const html = addresses.map(el => this._generateMarkup(el)).join(' ')

		tableBody.insertAdjacentHTML('afterbegin', html)
	}

	renderSpinner = function () {
		this._parentEl.querySelector('.table-message').classList.add('hidden')
		const parentEl = this._parentEl
		const html = this._generateSpinner()

		parentEl.insertAdjacentHTML('beforeend', html)
	}
}

export default new DistanceView()
